import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import {
  COMPTABLE_EXPERTISE_ID,
  MECHANICAL_EXPERTISE_ID,
} from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import messages from 'containers/LawyerLegalProceedingsPage/messages';
import { translate } from 'containers/services/translate';
import {
  EXPERTISES,
  EXPERTISES_FIELDS,
  EXPERTISE_TYPE,
} from 'containers/data-structure';
import { TextField, InputAdornment } from '@material-ui/core';
export interface VehicleExpertiseProps {
  intl: IntlShape;
  dahirAmounts: { [key: string]: number };
  isAppeal?: boolean;
  expertiseType: any;
  handleVehiculeChange: Function;
  vehicle: any;
  expertises: any;
  isInputChanged: any;
  index: any;
  setExpertiseFieldValue: any;
  sagisOpposingParties: any;
  isDisabled: boolean;
}

const VehicleExpertise: React.FC<VehicleExpertiseProps> = ({
  isAppeal,
  expertiseType,
  ...props
}): JSX.Element => {
  return (
    <main>
      {expertiseType === EXPERTISES.MECHANICAL_EXPERTISE ? (
        <TextField
          id={EXPERTISES_FIELDS.MECHANICAL_EXPERTISE}
          name={EXPERTISES_FIELDS.MECHANICAL_EXPERTISE}
          label={translate(messages.damageAmountFieldTitle, props)}
          value={props.setExpertiseFieldValue(
            String(props.vehicle.id),
            'damageAmount',
          )}
          onChange={props.handleVehiculeChange(
            props.vehicle.id,
            MECHANICAL_EXPERTISE_ID,
          )}
          className="calculated-amount"
          type="number"
          error={
            (props.expertises[expertiseType][props.index] === undefined ||
              !props.expertises[expertiseType][props.index]?.damageAmount) &&
            props.expertises[expertiseType][props.index]?.damageAmount !== 0 &&
            !props.isInputChanged
          }
          helperText={
            (props.expertises[expertiseType][props.index] === undefined ||
              !props.expertises[expertiseType][props.index]?.damageAmount) &&
            props.expertises[expertiseType][props.index]?.damageAmount !== 0 &&
            !props.isInputChanged
              ? translate(messages.validateRequiredField, props)
              : ''
          }
          disabled={props.isDisabled}
        />
      ) : (
        <TextField
          name="evaluationAmount"
          id="evaluationAmount"
          className="calculated-amount"
          label={translate(messages.damageAmountFieldTitle, props)}
          value={props.setExpertiseFieldValue(
            EXPERTISE_TYPE.VEHICULE,
            String(props.vehicle.id),
            'evaluationAmount',
          )}
          type="number"
          onChange={props.handleVehiculeChange(
            props.vehicle.id,
            COMPTABLE_EXPERTISE_ID,
          )}
          error={
            (props.expertises[expertiseType][props.index] === undefined ||
              !props.expertises[expertiseType][props.index]
                ?.evaluationAmount) &&
            props.expertises[expertiseType][props.index]?.evaluationAmount !==
              0 &&
            !props.isInputChanged
          }
          helperText={
            (props.expertises[expertiseType][props.index] === undefined ||
              !props.expertises[expertiseType][props.index]
                ?.evaluationAmount) &&
            props.expertises[expertiseType][props.index]?.evaluationAmount !==
              0 &&
            !props.isInputChanged
              ? translate(messages.validateRequiredField, props)
              : ''
          }
          disabled={props.isDisabled}
        />
      )}
      {!isAppeal && (
        <TextField
          name={EXPERTISES_FIELDS.PROVISIONNAL_EXECUTION}
          className="calculated-amount"
          label={translate(messages.provisionalExecution, props)}
          value={
            expertiseType === EXPERTISES.MECHANICAL_EXPERTISE
              ? props.setExpertiseFieldValue(
                  String(props.vehicle?.id),
                  'provisionalExecution',
                )
              : props.setExpertiseFieldValue(
                  EXPERTISE_TYPE.VEHICULE,
                  String(props.vehicle?.id),
                  'provisionalExecution',
                )
          }
          onChange={props.handleVehiculeChange(
            props.vehicle.id,
            expertiseType === EXPERTISES.MECHANICAL_EXPERTISE
              ? MECHANICAL_EXPERTISE_ID
              : COMPTABLE_EXPERTISE_ID,
          )}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {translate({ ...messages.responsibiltySharePercentage }, props)}
              </InputAdornment>
            ),
          }}
          type="number"
          error={
            (props.expertises[expertiseType][props.index] === undefined ||
              !props.expertises[expertiseType][props.index]
                ?.provisionalExecution) &&
            props.expertises[expertiseType][props.index]
              ?.provisionalExecution !== 0 &&
            !props.isInputChanged
          }
          helperText={
            (props.expertises[expertiseType][props.index] === undefined ||
              !props.expertises[expertiseType][props.index]
                ?.provisionalExecution) &&
            props.expertises[expertiseType][props.index]
              ?.provisionalExecution !== 0 &&
            !props.isInputChanged
              ? translate(messages.validateRequiredField, props)
              : ''
          }
          disabled={props.isDisabled}
        />
      )}
    </main>
  );
};

export default injectIntl(VehicleExpertise);
